// removed by extract-text-webpack-plugin
module.exports = {"selectColor":"qempo_SamsungGalaxy_selectColor-1CV2wy-","circle":"qempo_SamsungGalaxy_circle-3qsT-y1","cosmic-gray":"qempo_SamsungGalaxy_cosmic-gray-2xloL8X","cosmic-black":"qempo_SamsungGalaxy_cosmic-black-3UmtGD8","cloud-blue":"qempo_SamsungGalaxy_cloud-blue-1u7dGbc","cloud-pink":"qempo_SamsungGalaxy_cloud-pink-2BS3RkY","selectCapacity":"qempo_SamsungGalaxy_selectCapacity-1Z5rvMk","price":"qempo_SamsungGalaxy_price-_WoRGhD","capacity":"qempo_SamsungGalaxy_capacity-_UyEDVg","selectSize":"qempo_SamsungGalaxy_selectSize-3yxulxJ","size":"qempo_SamsungGalaxy_size-3sMpyOO"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/custom-products/Samsung/components/SamsungGalaxy.scss
// module id = 2192
// module chunks = 0